import api from "./api";

function addEditScore(currentUrl: string) {
  const editScore = Math.random().toString(36).substring(7);
  // if currentUrl already has editScore, replace it
  if (currentUrl.includes("#editScore=")) {
    return currentUrl.replace(
      /editScore=[a-zA-Z0-9]+/,
      `editScore=${editScore}`
    );
  } else {
    return currentUrl + `#editScore=${editScore}`;
  }
}

export async function editDocument(documentId: string, doc: any) {
  try {
    const res = await api.put(`/documents/${documentId}`, doc);
    window.location.href = addEditScore(window.location.href);
    return res.data;
  } catch (error) {
    return { status: false };
  }
}
